import mintPassesData from '../data/products/mint-passes.json';
export function getMintPassNameFromKey(keys) {
    var result = [];
    var _loop_1 = function (key) {
        var foundMintPass = mintPassesData.find(function (mintPass) { return mintPass.key === key; });
        if (foundMintPass) {
            result.push(foundMintPass.name);
        }
    };
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        _loop_1(key);
    }
    return result;
}
export function getNumberingsToFilter(_value) { }
